import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import registration2627 from "../../images/flyers/registration2627.jpg";
// import SummerDance2026 from "../../assets/Summer Dance 2026.pdf";
import FallSession2627 from "../../assets/26-27FallRegistration.pdf";
import downloadFile from "../../utils/downloadFile";
import styles from "./FlyerDownloads.module.css";

// const TICKET_LINK =
//   "https://unmtickets.evenue.net/events/FSH26?utm_source=ig&utm_medium=social&utm_content=link_in_bio&fbclid=PAZnRzaAQ-UZRleHRuA2FlbQIxMQBzcnRjBmFwcF9pZA8xMjQwMjQ1NzQyODc0MTQAAafyvnVr9IbWzY42006wD26d3FlT7RDNsEudqZ6-O2o-43w0MrpgYVinZLeABQ_aem_-VEicJvWh1Zbh4xqJwCVWA";

const FlyerDownloads = () => {
  const [isOpen, setIsOpen] = useState(false);

  const flyer = {
    title: "26/27 ",
    file: FallSession2627,
    filename: "Fishback-Studio-Fall-Session-2026-2027.pdf",
    image: registration2627,
  };

  const handleDownload = () => {
    downloadFile(flyer.file, flyer.filename);
  };

  // const handleSummerDanceDownload = () => {
  //   downloadFile(SummerDance2026, "Fishback-Studio-Summer-Dance-2026.pdf");
  // };

  const handleFallSessionDownload = () => {
    downloadFile(FallSession2627, "Fishback-Studio-Fall-Session-2026-2027.pdf");
  };

  return (
    <>
      <motion.button
        className={styles.floatingButton}
        onClick={() => setIsOpen(true)}
        initial={{ scale: 1 }}
        animate={{ scale: [1, 1.1, 1] }}
        transition={{ duration: 1.5, repeat: Infinity, repeatType: "reverse" }}
      >
        26/27 Season Registration
      </motion.button>

      <AnimatePresence>
        {isOpen && (
          <motion.div
            className={styles.overlay}
            initial={{ opacity: 0, y: -30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.3 }}
          >
            <div className={styles.overlayContent}>
              <div className={styles.overlayHeader}>
                <span className={styles.overlayTitle}>
                  26/27 Season Information
                </span>
                <button
                  className={styles.closeButton}
                  onClick={() => setIsOpen(false)}
                >
                  Close
                </button>
              </div>

              <motion.img
                src={flyer.image}
                alt={flyer.title}
                className={styles.flyerImageLarge}
                onClick={handleDownload}
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.97 }}
                style={{ cursor: "pointer" }}
              />

              <div className={styles.ctaContainer}>
                {/* <motion.button
                  className={styles.primaryButton}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleDownload}
                >
                  Download Recital Flyer
                </motion.button>
                <motion.button
                  className={styles.primaryButton}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleSummerDanceDownload}
                >
                  Summer Dance, Register Now!
                </motion.button> */}
                <motion.button
                  className={styles.primaryButton}
                  whileTap={{ scale: 0.95 }}
                  onClick={handleFallSessionDownload}
                >
                  Fall Session 26/27 Registration
                </motion.button>
                {/* <motion.button
                  className={styles.secondaryButton}
                  whileTap={{ scale: 0.95 }}
                  onClick={() =>
                    window.open(TICKET_LINK, "_blank", "noopener,noreferrer")
                  }
                >
                  Buy Recital Tickets
                </motion.button> */}
              </div>
            </div>
          </motion.div>
        )}
      </AnimatePresence>
    </>
  );
};

export default FlyerDownloads;
